export const environment = {
  production: false,
  apiUrl: "https://b2b2c-api-stage.awpassistance.in",
  payuUrl: "https://sboxcheckout-static.citruspay.com/bolt/run/bolt.min.js",
  nsmCount: 1,
  rsmCount: 5,
  asmCount: 25,
  financeCount: 1,
  //gCaptchaKey: "6LepOewjAAAAADhrXVYwdFX2ZzmDfb5zXdZFWBhc",
  //gCaptchaSecret: "6LepOewjAAAAAH6PqidY8XPMErD7rVdtrtrWnqN9",
  gCaptchaKey: "6LePhDQsAAAAAJ6wp4XB2jZykb_yCHu9AeHUKXzX",
  gCaptchaSecret: "6LePhDQsAAAAAEK_Bl12vY5s1xwj9Jp-086tI3pZ",
  
  maxvehicleAge: 6,
};
